import React, {useEffect, useRef} from "react";
import StickyNavbar from '../reuse-component/Navbar/StickyNavbar';
import FooterSection from "../homepage/component/FooterSection";
import Services from '../../services/contactUs'
import PrivacyComponent from "./_components/PrivacyComponent";

function LodapointAppPrivacy() {
  const monitoringInitiated = useRef(false);
  useEffect(() => {
    if (!monitoringInitiated.current) {
      Services.monitor();
      monitoringInitiated.current = true;
    }
  }, []);

  return (
    <>
      <StickyNavbar />
      <PrivacyComponent />
      <FooterSection />
    </>
  );
}

export default LodapointAppPrivacy;
